var ProductsCategories = $.extend(false, BaseModule ,{

    api_route : 'catalogue/categories',

    data : {
        module      : 'products-categories',
        with        : 'icon_file:parent_category:parts',
        view        : 'grid',
        pagination  : true,
        limit       : 42,
        order_by    : 'id:desc'
    },
	

	order:function(v){
		var module_name = this.data.module;
		var module = this;
		$( "#"+module_name+"-categories-order-dialog-form" ).dialog('close');
		$( "#"+module_name+"-categories-order-dialog-form" ).dialog({
			autoOpen: true,
			height:	700,
			width: 1100,
			modal:false,
			title:'Order '+module_name,
			buttons:{
				"Update":function(){
					module.update_order();
					return false;
				},
				"Cancel":function(){
					$( this ).dialog('close');			
				}
			},
			open:function(){
				$(this).html('<div id="order_'+module_name+'_categories" style="clear:both">Loading ...</div>');
				$.ajax({data:{	module:			module_name,
								action:			"load-"+module_name+"-categories-order-list",
								data_type:		'html',
								view:			module.data.view,
								page:			module.data.page,
								offset:			module.data.offset,
								sort_term:		'`order`',
								sort_way:		'ASC',
								cid:			v},
						dataType:'html',success:function(data){
							$( '#order_'+module_name+'_categories').html(data).show();
							$( '#order_'+module_name+'_categories table tbody').sortable();
							$( '#order_'+module_name+'_categories table tbody').disableSelection();

				}});	
			},
			close: function() {
				$( this ).dialog('destroy');			
				$( this ).empty();
			}
		});	
	},


    save_order:function(){
        var module_name = this.data.module;
        var module = this;
        $.ajax({data:$('.'+module_name+'-order-form form').serialize(),success:function(data){
            if(data.status == 'ok'){
                GlobalModule.show_message('success',data.message);
                GlobalModule.show_message('success','Your updates/additions have been saved. Please wait 5 min for changes to take affect');
                module.load_list();
            }else{
                GlobalModule.show_message('danger',data.error);
            }
        }});
        return false;
    },


    load_order_list:function(){
        var module_name = this.data.module,
            module = this,
            request_data = $.extend(false, {}, module.data);
        request_data.module  = module_name.split('-')[0];
        request_data.action  = "load-"+module_name+"-order-list";
        request_data.data_type = 'html';
        request_data.search_param = '';

        $('.' + module_name + '-wrapper').hide();
        $('.' + module_name + '-form').hide();
        $('.' + module_name + '-order-form').html('<span class="spinner"><i class="fa fa-spinner fa-spin"></i></span>').show();

        $.ajax({
            data:request_data,
            dataType:'html',
            success:function(data){
                $('.'+module_name+'-order-form').html(data);
                $('.'+module_name+'-order-form #nestable').nestable({
                    group: 0
                }).on('change', function(e,x,v) {
                    console.log(e,x,v);
                });
            }
        });
    },


     init:function(){
        "use strict";
        var module_name = this.data.module,
            module = this;
    }

});

$(document).ready(function(){
    "use strict";
	ProductsCategories.init();
});
